import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Card, CardContent, CardDescription, CardHeader, CardTitle,
} from "@/components/ui/card";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";
import { Copy, Share2, QrCode } from "lucide-react";
import { toast } from "sonner";
import { QRCodeSVG } from "qrcode.react";
const QRCode = QRCodeSVG;

const ShareApplyLink = () => {
  const [open, setOpen] = useState(false);
  const PUBLIC_SITE_URL = "https://rcnmo.com";
  const url = `${PUBLIC_SITE_URL}/apply`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied to clipboard");
    } catch {
      toast.error("Could not copy link");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Apply to join RCN",
          text: "Apply for membership in the Referral Connection Network",
          url,
        });
      } catch {
        // user cancelled
      }
    } else {
      copy();
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Share the Application Link</CardTitle>
        <CardDescription>
          Know someone who'd be a great fit? Send them a direct link to apply for membership.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex gap-2">
          <Input readOnly value={url} className="font-mono text-sm" />
          <Button variant="outline" onClick={copy} title="Copy link">
            <Copy className="h-4 w-4" />
          </Button>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button onClick={nativeShare}>
            <Share2 className="h-4 w-4 mr-2" /> Share
          </Button>
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
              <Button variant="outline">
                <QrCode className="h-4 w-4 mr-2" /> Show QR
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-xs">
              <DialogHeader>
                <DialogTitle>Apply to RCN</DialogTitle>
                <DialogDescription>Scan to open the application form.</DialogDescription>
              </DialogHeader>
              <div className="flex justify-center bg-white p-4 rounded">
                <QRCode value={url} size={220} />
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </CardContent>
    </Card>
  );
};

export default ShareApplyLink;
